<template>
  <div class="wrapper">
    <template v-if="list?.length">
      <div class="list">
        <template v-for="(item, index) in list" :key="item.id">
          <Photo :item="item" @onPlay="handlePlay(item, index)"></Photo>
        </template>
        <div ref="loaderIdentifier" style="height: 0.1px; opacity: 0; column-span: all"></div>
      </div>
    </template>
    <div v-else-if="loading" style="height: 5rem; background-color: #000;">
    </div>
    <div v-else-if="list.length === 0 && !loading" style="display: flex; flex-direction: column; align-items: center">
      <img src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/empty.png"
        style="width: 1.8rem; height: 2rem; padding-bottom: 0.2rem; margin-top: 0.4rem" />
      <p style="color: rgba(255, 255, 255, 0.4); font-size: 0.25rem;
      padding-bottom: 2rem">
        暂无内容
      </p>
    </div>
    <div class="bottom-more" v-show="showMoreBtn && list.length !== 0">
      <div @click="handleMore" style="cursor: pointer;">
        <img v-if="isLargeScreen === false" class="more"
          src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/moreBtnSmall.png" />
        <img v-else @click="handleMore" class="more"
          src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/moreBtnBig.png" />
      </div>
    </div>
  </div>

</template>
<script setup lang="ts">
import Photo from "./Photo.vue";
import { ref } from "vue";
import { showToast } from "vant";
import { PublishListItem, getPublishList } from "./api/request";
import { ApiModal } from "~/composables/apiModal";
import VideoPlayModal from "../modal/videoPlayModal.vue";
import useDevice from "./useDevice";

const props = withDefaults(
  defineProps<{
    type: Parameters<typeof getPublishList>[0]["type"];
  }>(),
  { type: "all" },
);
type Event = {
  (e: "showMask", isShowMask: boolean): void;
};
const emit = defineEmits<Event>();
const list = ref<PublishListItem[]>([]);
const { isMobile } = useDevice();
const loaderIdentifier = ref(null);
const pcursor = ref(0);
const loading = ref(false);
const showMoreBtn = ref(true);
const playModal = ref<ApiModal<typeof VideoPlayModal>>();

const handleMore = () => {
  getData();
  if (pcursor.value < 0) {
    showToast({
      message: '<div style="justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">没有更多了~</div>',
      type: 'html'  //所加样式名
    });
    emit("showMask", false);
  }
};
const handlePlay = (item: PublishListItem, index: number) => {
  if (!playModal.value) {
    playModal.value = new ApiModal(VideoPlayModal);
  }
  playModal.value.show({
    // @ts-ignore
    closeOnClickOverlay: isMobile.value,
    items: list.value,
    index,
    // @ts-ignore
    onNext: async () => {
      await getData();
      playModal.value?.show({ items: list.value, index });
      playModal.value?.instance?.$forceUpdate(); // 触发强制更新
    },
    onClose() {
      playModal.value?.destroy();
    }
  });
};

const getData = () => {
  if (pcursor.value < 0) {
    showToast({
      message: '<div style="justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">没有更多了~</div>',
      type: 'html'  //所加样式名
    });
    showMoreBtn.value = false;
    emit("showMask", false);
    return;
  }
  loading.value = true;
  return getPublishList({ type: props?.type, pcursor: pcursor.value })
    .then((data) => {
      const submissionList = data?.data?.submissionList ?? [];
      const uniqueList = new Map([...list.value, ...submissionList].map((it, i) => [it.photoId ?? i, it]))
      list.value = Array.from(uniqueList.values()); // [...list.value, ...(data?.data?.submissionList ?? [])];
      pcursor.value = data?.data?.pcursor;
      if (data?.data?.submissionList.length < 10) {
        showMoreBtn.value = false;
        emit("showMask", false);
      } else {
        emit("showMask", true);
      }
    })
    .finally(() => (loading.value = false));
};

onMounted(() => {
  getData();
});
const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})
</script>

<style lang="less" scoped>
.wrapper {
  margin-top: 0.88rem;
  width: 22.36rem;
  // max-height: 14.4rem;
  // overflow: auto;
  // overscroll-behavior-y: none;
  position: relative;

  @media screen and (max-width:1360px) and (min-width:700px) {
    max-width: 80vw;
  }

  @media screen and (max-width: 1360px) {
    width: calc(100vw - 2 * 0.4rem);
    margin-top: 0.36rem;
  }

  .list {
    column-count: 3;
    column-gap: 0.13rem;
    column-fill: balance;
    width: 100%;
    position: relative;

    @media screen and (max-width: 1360px) {
      column-count: 2;
    }

    @media screen and (max-width:1360px) and (min-width:700px) {
      column-count: 3;
    }

    :deep(.box.card) {
      .play {
        width: .88rem;
        height: .88rem;
      }
    }
  }

  .item {
    overflow: hidden;
    margin-bottom: -0.08rem;

    & img {
      width: 100%;
      height: auto;
    }
  }

  .bottom-more {
    width: 100%;
    height: 4rem;
    position: absolute;
    bottom: 0;
    left: 0;
    // background-size: 100% 100%;
    //p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/1cfaf95e-449e-4619-919b-bd50eba827f7.png);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;

    @media screen and (max-width: 1360px) {
      height: 2.4rem;
    }

    .van-empty__image {
      width: 2rem;
      /* 设置图片宽度 */
      height: 2rem;
      /* 设置图片高度 */
    }

    .more {
      height: 1.2rem;
      padding: 0 0.2rem 0 0.4rem;
      background: none;

      @media screen and (max-width: 1360px) {
        height: 0.8rem;
        padding: 0 0.24rem;
      }

      :deep(.van-button) {
        &__text {
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(97.03deg,
              #ffffff 20.89%,
              #b5ffdf 62.65%,
              #9cedff 83.53%,
              #97b4ff 104.41%);
          color: transparent;
          background-clip: text;
          height: 100%;
          font-size: 0.4rem;
          line-height: 0.56rem;
          font-weight: 600;

          @media screen and (max-width: 1360px) {
            font-size: 0.24rem;
            font-weight: 500;
            line-height: 0.32rem;
          }
        }
      }

      .more_text {
        display: inline-block;
        background: linear-gradient(97.03deg,
            #ffffff 20.89%,
            #b5ffdf 62.65%,
            #9cedff 83.53%,
            #97b4ff 104.41%);
        color: transparent;
        background-clip: text;
      }

      .more-img {
        height: 0.64rem;

        @media screen and (max-width: 1360px) {
          height: 0.4rem;
          width: 0.4rem;
        }
      }
    }
  }
}
</style>
